import React from 'react';
import PropTypes from 'prop-types';

import EventIcon from '../../../../../core/gd-components/icons/event-icon'
import EventModel from 'core/gd-model/event/event';
import FormError from 'src/core/gd-form/common/form-error/form-error';
import InfoPanelRow from "src/core/gd-ui/ip-section-row/info-panel-row";
import FieldsCollection from "src/core/fields3/collection/base/fields-collection";
import {FIELDS} from "src/core/fields3/fields.const";
import FieldFormElement from "../../../../fields3/render/form-elemnent";

export default class ReassignUserEvents extends React.Component {
    static propTypes = {
        form: PropTypes.object,
        userOptions: PropTypes.array,
        events: PropTypes.array,
    }

    constructor(props) {
        super(props);

        this.fields = new FieldsCollection([
            { fieldId: 'eventsReassignTo',   type: FIELDS.USER,  options: this.props.userOptions},
        ]);
    }

    renderEventsList = () => {
        let res = [];
        _.map(this.props.events, (event,key)=>{
            const eventModel = new EventModel(event,{parse:true});

            res.push(
                <div key={key} className="row">
                    <div className="cell">
                        <EventIcon className="ui5-ico-13 m-r-10" event={eventModel} hint={false} />
                        <div className="ui5-txt-default max-w-300">{event.name}</div>
                    </div>
                </div>
            )
        });

        return (
            <React.Fragment>
                <div className="ui5-list h-40">
                    {res}
                </div>

                <InfoPanelRow className="m-t-15" label="Re-assign to">
                    {/*{this.fields.get("eventsReassignTo").render.formElement(this.props.form, 'w-300')}*/}
                    <FieldFormElement field={this.fields.get("eventsReassignTo")} form={this.props.form} className="w-300" />
                </InfoPanelRow>

                <FormError className="w-100-percent" form={this.props.form} name="eventsReassignTo" />
            </React.Fragment>
        )
    }

    render() {
        if (!this.props.events || this.props.events.length < 1) return false;

        return (
            <React.Fragment>
                <div className="ui5-title-small m-t-20">Events</div>
                {this.renderEventsList()}
            </React.Fragment>
        )
    }
}
